<template>
  <h2
    v-if="type === 'page'"
    class="mb-0 text-primary text-uppercase font-weight-bold"
  >
    {{$t(title)}}
  </h2>
  <h3
    v-else-if="type === 'section'"
    class="mb-0 text-secondary font-weight-bold"
  >
    {{$t(title) | capitalize}}
  </h3>
  <h4
    v-else-if="type === 'sub-section-1'"
    class="mb-0 text-dark font-weight-bold"
  >
    {{$t(title) | capitalize}}
  </h4>
  <h5
    v-else-if="type === 'sub-section-2'"
    class="mb-0 text-dark"
  >
    {{$t(title) | capitalize}}
  </h5>
</template>

<script>
  export default {
    name: "AppTitle",
    props: {
      title: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'section',
        validator: function (value) {
          return ['page', 'section', 'sub-section-1', 'sub-section-2'].indexOf(value) !== -1
        }
      }
    }
  }
</script>

<style scoped>
  .border-bottom {
    border-bottom: 1px solid rgba(0,0,0,.25) !important;
  }
</style>
